import dayjs from "dayjs";
import { CRON } from "..";
/**
 * Class of a cron object in quartz format.
 * @author Nico Vitt
 */
export class QuartzObject {
    constructor(startdate) {
        this._delimiters = ["/", ",", "-", "#"];
        this.weekdayabbr = [
            "MON",
            "TUE",
            "WED",
            "THU",
            "FRI",
            "SAT",
            "SUN",
        ];
        this.monthabbr = [
            "JAN",
            "FEB",
            "MAR",
            "APR",
            "MAY",
            "JUN",
            "JUL",
            "AUG",
            "SEP",
            "OKT",
            "NOV",
            "DEZ",
        ];
        this.rules = [
            {
                field: "DAYOFMONTH",
                setter: "dayofmonth",
                modify: (value, state) => {
                    if (!value) {
                        return CRON.DEFAULT.split(" ")[5];
                    }
                    if (state.timeSeries === "daily") {
                        if (typeof value === "number") {
                            if (value > 1) {
                                // return state.startdate.get("date") + "/" + value;
                                return "*/" + value;
                            }
                            else {
                                return "*";
                            }
                        }
                        //If value is string, return this value
                        if (typeof value === "string") {
                            return value;
                        }
                    }
                    if (state.timeSeries === "monthly") {
                        return value + "";
                    }
                    return value.toString();
                },
                rules: [
                    {
                        field: "DAYOFWEEK",
                        modify: () => {
                            return "?";
                        },
                    },
                ],
            },
            {
                field: "MONTH",
                setter: "month",
                modify: (value, state) => {
                    if (!value) {
                        return "*";
                    }
                    return 1 + "/" + value;
                },
                rules: [],
            },
            {
                field: "DAYOFWEEK",
                setter: "dayofweek",
                modify: (value, state) => {
                    if (!value || (Array.isArray(value) && value.length === 0)) {
                        return "?";
                    }
                    if (state.timeSeries === "weekly") {
                        if (typeof value === "number") {
                            return this.weekdayabbr[value];
                        }
                        // const monthrest = (v * 7) % 4;
                        // const month = 1 + "/" + (Math.floor(v / 4) + 1);
                        // state.quartzobject.week = state.startdate.week() + "/" + v;
                        // state.quartzobject.dayofmonth = state.startdate.get("date").toString() + "/" + v * 7;
                        // state.quartzobject.month = month;
                        return this.getDayOfWeekAbbreviation(value, "string", undefined, ",");
                    }
                    if (state.timeSeries === "monthly") {
                        if (state.monthlySwitcher === 2) {
                            if (typeof value === "number") {
                                return ((this.START_DOW ? this.START_DOW : "1") +
                                    (this.DELIMITER_DOW ? this.DELIMITER_DOW : "#") +
                                    value);
                            }
                            if (typeof value === "string") {
                                return value;
                            }
                            if (Array.isArray(value)) {
                                return (this.getDayOfWeekAbbreviation(value, "number", undefined, ",") +
                                    "#" +
                                    (this.END_DOW ? this.END_DOW : "1"));
                            }
                        }
                    }
                },
                rules: [
                    {
                        field: "DAYOFMONTH",
                        modify: () => {
                            if (this.dayofweek === "?") {
                                return "*";
                            }
                            return "?";
                        },
                    },
                ],
            },
            {
                field: "YEAR",
                setter: "year",
                modify: (value, state) => {
                    // const currentyearValue = state.getFieldsFromCronString([
                    //   CRON.RegexGroupNames.START_YR,
                    //   CRON.RegexGroupNames.DELIMITER_YR,
                    //   CRON.RegexGroupNames.END_YR,
                    // ]);
                    // this.dayofweek = "?";
                    // this.dayofmonth = state.startdate.get("date").toString();
                    // this.month = this.getMonthAbbreviation(
                    //   [state.startdate.month()],
                    //   "string",
                    //   undefined,
                    //   ","
                    // );
                    if (!value) {
                        return "*";
                    }
                    let years = "";
                    if (state.currentEnddate && value > 1) {
                        const yearDiff = state.currentEnddate.diff(state.startdate, "years");
                        let i = 0;
                        while (i <= yearDiff) {
                            if (i % value === 0) {
                                years = years.concat(dayjs(state.startdate).add(i, "year").get("year").toString());
                                if (i + value <= yearDiff) {
                                    years = years.concat(",");
                                }
                            }
                            i++;
                        }
                    }
                    else if (state.currentEnddate) {
                        years = `${state.startdate.get("year")}-${state.currentEnddate.get("year")}`;
                    }
                    else {
                        years = `${state.startdate.get("year").toString()}/${value}`;
                    }
                    return years;
                },
                rules: [],
            },
        ];
        this.SECOND = CRON.DEFAULT.split(" ")[0];
        this.MINUTE = CRON.DEFAULT.split(" ")[1];
        this.HOUR = CRON.DEFAULT.split(" ")[2];
        this.DAYOFWEEK = CRON.DEFAULT.split(" ")[3];
        this.MONTH = CRON.DEFAULT.split(" ")[4];
        this.DAYOFMONTH = CRON.DEFAULT.split(" ")[5];
        this.YEAR = CRON.DEFAULT.split(" ")[6];
        if (typeof startdate !== "undefined") {
            this.updateStartdate(startdate);
        }
    }
    get seconds() {
        return this.SECOND;
    }
    set seconds(v) {
        let found = false;
        for (const entry of this._delimiters) {
            if (v.includes(entry)) {
                found = true;
                const splittedarr = v.split(entry);
                this.START_SEC = splittedarr[0];
                this.DELIMITER_SEC = entry;
                this.END_SEC = splittedarr[1];
            }
        }
        if (!found) {
            this.START_SEC = undefined;
            this.DELIMITER_SEC = undefined;
            this.END_SEC = undefined;
        }
        this.SECOND = v;
    }
    get minutes() {
        return this.MINUTE;
    }
    set minutes(v) {
        let found = false;
        for (const entry of this._delimiters) {
            if (v.includes(entry)) {
                found = true;
                const splittedarr = v.split(entry);
                this.START_MIN = splittedarr[0];
                this.DELIMITER_MIN = entry;
                this.END_MIN = splittedarr[1];
            }
        }
        if (!found) {
            this.START_MIN = undefined;
            this.DELIMITER_MIN = undefined;
            this.END_MIN = undefined;
        }
        this.MINUTE = v;
    }
    get hours() {
        return this.HOUR;
    }
    set hours(v) {
        let found = false;
        for (const entry of this._delimiters) {
            if (v.includes(entry)) {
                found = true;
                const splittedarr = v.split(entry);
                this.START_HR = splittedarr[0];
                this.DELIMITER_HR = entry;
                this.END_HR = splittedarr[1];
            }
        }
        if (!found) {
            this.START_HR = undefined;
            this.DELIMITER_HR = undefined;
            this.END_HR = undefined;
        }
        this.HOUR = v;
    }
    get dayofmonth() {
        return this.DAYOFMONTH;
    }
    set dayofmonth(v) {
        let found = false;
        for (const entry of this._delimiters) {
            if (v.includes(entry)) {
                found = true;
                const splittedarr = v.split(entry);
                this.START_DOM = splittedarr[0];
                this.DELIMITER_DOM = entry;
                this.END_DOM = splittedarr[1];
            }
        }
        if (!found) {
            this.START_DOM = undefined;
            this.DELIMITER_DOM = undefined;
            this.END_DOM = undefined;
        }
        this.DAYOFMONTH = v;
    }
    get month() {
        return this.MONTH;
    }
    set month(v) {
        let found = false;
        for (const entry of this._delimiters) {
            if (v.includes(entry)) {
                found = true;
                const splittedarr = v.split(entry);
                this.START_MON = splittedarr[0];
                this.DELIMITER_MON = entry;
                this.END_MON = splittedarr[1];
            }
        }
        if (!found) {
            this.START_MON = undefined;
            this.DELIMITER_MON = undefined;
            this.END_MON = undefined;
        }
        this.MONTH = v;
    }
    get dayofweek() {
        return this.DAYOFWEEK;
    }
    set dayofweek(v) {
        let found = false;
        for (const entry of this._delimiters) {
            if (v.includes(entry)) {
                found = true;
                let splittedarr = v.split(entry);
                if (entry === ",") {
                    this.START_DOW = splittedarr[0];
                    this.END_DOW = splittedarr.slice(-1)[0];
                }
                else if (entry === "#") {
                    // splittedarr = v.split(",");
                    this.START_DOW = splittedarr[0];
                    this.END_DOW = splittedarr.slice(-1)[0];
                }
                else {
                    this.START_DOW = splittedarr[0];
                    this.END_DOW = splittedarr[1];
                }
                this.DELIMITER_DOW = entry;
            }
        }
        if (this.weekdayabbr.includes(v)) {
            //If v is only one weekday
            this.DELIMITER_DOW = "/";
        }
        if (!found) {
            this.START_DOW = undefined;
            this.DELIMITER_DOW = undefined;
            this.END_DOW = undefined;
        }
        this.DAYOFWEEK = v;
    }
    get year() {
        return this.YEAR;
    }
    set year(v) {
        let found = false;
        for (const entry of this._delimiters) {
            if (v.includes(entry)) {
                found = true;
                const splittedarr = v.split(entry);
                this.START_YR = splittedarr[0];
                this.DELIMITER_YR = entry;
                this.END_YR = splittedarr[1];
            }
        }
        if (!found) {
            this.START_YR = undefined;
            this.DELIMITER_YR = undefined;
            this.END_YR = undefined;
        }
        this.YEAR = v;
    }
    toString() {
        return (this.seconds +
            " " +
            this.minutes +
            " " +
            this.hours +
            " " +
            this.dayofmonth +
            " " +
            this.month +
            " " +
            this.dayofweek +
            " " +
            this.year);
    }
    /**
     * Resets the cron object to the default values.
     */
    reset() {
        this.SECOND = CRON.DEFAULT.split(" ")[0];
        this.MINUTE = CRON.DEFAULT.split(" ")[1];
        this.HOUR = CRON.DEFAULT.split(" ")[2];
        this.DAYOFWEEK = CRON.DEFAULT.split(" ")[3];
        this.MONTH = CRON.DEFAULT.split(" ")[4];
        this.DAYOFMONTH = CRON.DEFAULT.split(" ")[5];
        this.YEAR = CRON.DEFAULT.split(" ")[6];
    }
    /**
     * Returns the value of the form field for the given type.
     * @param type
     * @returns
     */
    getInitialFormValue(type) {
        return CRON.DefaultFormFields[type];
    }
    /**
     *
     * @param value
     * @param type
     * @param suffix
     * @param joinBy
     * @returns string
     */
    getDayOfWeekAbbreviation(value, type, suffix, joinBy) {
        return value
            .sort((a, b) => a - b)
            .map((weekdayindex) => {
            return type === "number"
                ? weekdayindex + 1 + (suffix ? suffix : "")
                : type === "string"
                    ? this.weekdayabbr[weekdayindex] + (suffix ? suffix : "")
                    : null;
        })
            .join(joinBy);
    }
    /**
     * Maps a number array of months to the abbreviations (number or stirng)
     * @param value
     * @param type
     * @param suffix
     * @param joinBy
     * @returns
     */
    getMonthAbbreviation(value, type, suffix, joinBy) {
        return value
            .sort((a, b) => a - b)
            .map((monthindex) => {
            return type === "number"
                ? monthindex + 1 + (suffix ? suffix : "")
                : type === "string"
                    ? this.monthabbr[monthindex] + (suffix ? suffix : "")
                    : null;
        })
            .join(joinBy);
    }
    /**
     * Updates the fields when startdate changes.
     */
    updateStartdate(startdate) {
        this.seconds = startdate.get("second").toString();
        this.minutes = startdate.get("minute").toString();
        this.hours = startdate.get("hour").toString();
        this.dayofmonth = startdate.get("date").toString() + "/" + 1;
        this.month = (startdate.get("month") + 1).toString() + "/" + 1;
        this.year = startdate.get("year").toString() + "/" + 1;
    }
}
//# sourceMappingURL=CronObject.js.map